import { ApiError } from "@/lib/api-client";

const SERVER_ERROR_STATUS = 500;
const MAX_MESSAGE_LENGTH = 200;

/**
 * IAM list errors are operator-facing: 403/4xx copy from the API is the reason
 * the tab is empty. Generic customer sanitising would hide that. 5xx and
 * network faults still fall back — their text is for logs, not the pane.
 */
export function iamQueryErrorMessage(error: unknown, fallback: string): string {
  if (!(error instanceof ApiError) || error.status <= 0 || error.status >= SERVER_ERROR_STATUS) {
    return fallback;
  }
  const raw = error.message.trim();
  if (raw.length < 1 || raw.length > MAX_MESSAGE_LENGTH || /[\r\n]/.test(raw)) {
    return fallback;
  }
  return raw;
}
